if (!customElements.get("lumihi-countdown")) {
  customElements.define(
    "lumihi-countdown",
    class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        this.mode = this.dataset.mode || "deadline";
        this.duration =
          Math.max(1, Number(this.dataset.cycleHours) || 20) * 3600000;
        this.deadline =
          this.mode === "cycle"
            ? this.getCycleDeadline()
            : new Date(this.dataset.deadline).getTime();
        if (!Number.isFinite(this.deadline)) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      getCycleDeadline() {
        let deadline;
        try {
          deadline = Number(localStorage.getItem(this.dataset.storageKey));
        } catch (error) {
          deadline = 0;
        }
        if (!Number.isFinite(deadline) || deadline <= Date.now()) {
          deadline = Date.now() + this.duration;
          try {
            localStorage.setItem(this.dataset.storageKey, String(deadline));
          } catch (error) {}
        }
        return deadline;
      }
      tick() {
        let remaining = this.deadline - Date.now();
        if (remaining <= 0 && this.mode === "cycle") {
          this.deadline = Date.now() + this.duration;
          remaining = this.duration;
          try {
            localStorage.setItem(
              this.dataset.storageKey,
              String(this.deadline),
            );
          } catch (error) {}
        }
        if (remaining <= 0) {
          this.hidden = true;
          clearInterval(this.timer);
          return;
        }
        const values = {
          days: Math.floor(remaining / 86400000),
          hours: Math.floor(remaining / 3600000) % 24,
          minutes: Math.floor(remaining / 60000) % 60,
          seconds: Math.floor(remaining / 1000) % 60,
        };
        Object.entries(values).forEach(([key, value]) => {
          const node = this.querySelector(`[data-${key}]`);
          if (node) node.textContent = String(value).padStart(2, "0");
        });
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
    },
  );
}
